// extracted by mini-css-extract-plugin
export const button = "ReadMore-module--button--ME6TB";
export const content = "ReadMore-module--content--3GSy0";
export const expanded = "ReadMore-module--expanded--Vji75";
export const backgroundWhite = "ReadMore-module--background-white--3vK5x";
export const backgroundGray = "ReadMore-module--background-gray--1Npo8";